import { AxDataTable } from "@/components/ax/dataTable/AxDataTable";
import { useBreadcrumbs } from "@/hooks/useBreadcrumbs";
import { ROUTES } from "@/constants/routeConstants";
import { LoginLog } from "@/lib/types";
import { getLoginLog } from "@/sideEffects/api";
import { ColumnDef } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

export const LoginLogPage = () => {
  const { t } = useTranslation();

  useBreadcrumbs([{ name: t("entities.loginLog"), path: ROUTES.LOGIN_LOG }]);

  const columns: ColumnDef<LoginLog>[] = [
    {
      accessorKey: "id",
      header: t("id"),
    },
    {
      accessorKey: "time",
      header: t("common.time"),
    },
    {
      accessorKey: "userEmail",
      header: t("user.email"),
      cell: ({ row }) => {
        return <div className="text-xs">{row.original.userEmail}</div>;
      },
    },
  ];

  return (
    <div>
      <AxDataTable
        columns={columns}
        fetcher={getLoginLog}
        uniqQueryKey="getLoginLog"
        getRowId={(row) => row.id.toString()}
      />
    </div>
  );
};
